import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

export const useIsSearch = () => {
  const router = useRouter();
  const slug = router.query.slug as string;

  const { t } = useTranslation();
  const url = `/${t('search').trim().toLowerCase()}`;

  const searchUrl = `${url}${slug && `\/${slug}`}`;
  return {
    isSearchPage: router.asPath.startsWith(url),
    searchUrl,
    searchQuery: slug,
  };
};
